module.exports = __webpack_public_path__ + "img/img_sky_all_100.238200ce.png";